import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20watercolor%20background%20in%20dusty%20pink%20cream%20and%20blush%20tones%20with%20delicate%20organic%20flowing%20shapes%20and%20gentle%20gradients%20evoking%20a%20serene%20luxurious%20spa%20atmosphere%20subtle%20botanical%20and%20rose%20petal%20elements%20minimal%20artistic%20composition%20with%20airy%20negative%20space%20bright%20high%20key%20aesthetic&width=1920&height=1080&seq=bianca-hero-1&orientation=landscape"
          alt="비앙카 피부관리 히어로 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-white/5 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 pb-20 flex flex-col items-center text-center">
        <span className="animate-fade-in-up inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/70 backdrop-blur-sm border border-primary-200 text-sm font-medium text-primary-700">
          <i className="ri-sparkling-2-line"></i>
          프리미엄 스킨케어 전문샵
        </span>

        <h1
          className="animate-fade-in-up mt-6 text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight"
          style={{ animationDelay: "120ms" }}
        >
          피부 고민, 비앙카에서
          <br />
          빛나는 피부로 완성하세요
        </h1>

        <p
          className="animate-fade-in-up mt-6 text-sm md:text-lg text-foreground-600 max-w-2xl leading-relaxed"
          style={{ animationDelay: "240ms" }}
        >
          피부 고민별 맞춤 프로그램으로 건강하고 맑은 피부를 완성해드립니다.
          <br className="hidden sm:block" />
          전문 관리사의 세심한 손길로 진정한 피부 힐링을 경험하세요.
        </p>

        <div
          className="animate-fade-in-up mt-9 flex flex-col sm:flex-row items-center gap-3"
          style={{ animationDelay: "360ms" }}
        >
          <Link
            to="/reservation"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold whitespace-nowrap transition-all hover:bg-primary-600 cursor-pointer"
          >
            예약상담
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/programs"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-white/80 backdrop-blur-sm border border-primary-200 text-primary-700 text-base font-semibold whitespace-nowrap transition-all hover:bg-white cursor-pointer"
          >
            관리 프로그램 보기
          </Link>
        </div>

        <div
          className="animate-fade-in-up mt-14 grid grid-cols-3 gap-6 md:gap-12"
          style={{ animationDelay: "480ms" }}
        >
          {[
            { value: "1:1", label: "맞춤 관리" },
            { value: "10+", label: "전문 프로그램" },
            { value: "10년", label: "피부관리 경력" },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-1">
              <span className="text-2xl md:text-3xl font-bold font-heading text-primary-600">{stat.value}</span>
              <span className="text-xs md:text-sm text-foreground-600">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}